import WrapWithDropdownBody from "../WrapWithDropdownBody.vue";
import { SelectedSection } from "../sections";
import SellerFilterItem from "../items/SellerFilterItem.vue";
import ListSection from "../sections/ListSection.vue";
export default {
  name: "SellerFilterBody",
  components: {
    WrapWithDropdownBody,
    SelectedSection,
    SellerFilterItem,
    ListSection
  },
  emits: ["clear", "discard", "restoreSearch", "select", "deselect", "apply", "search", "hidden", "closeDropdown", "selectOnly"],
  props: {
    title: {
      type: String,
      default: ""
    },
    selected: {
      type: Array,
      default: () => []
    },
    list: {
      type: Array,
      default: () => []
    },
    isModified: {
      type: Boolean,
      default: false
    },
    // Filter.pendingChanges: { count, text } | string | null
    pendingChanges: {
      type: [Object, String],
      default: null
    },
    searching: {
      type: Boolean,
      default: false
    },
    isSearching: {
      type: Boolean,
      default: false
    },
    keyword: {
      type: [String, Array],
      default: ""
    },
    no_reset: {
      type: Boolean,
      default: false
    }
  }
};